<template>
    <div class="params">

        <div
            v-for="(param,key) in params"
            :key="key"
        >
            <div>
                <p>{{key}}:</p>
                <pre v-if="typeof(param) === 'string' && param.indexOf('{') > -1 ">{{ JSON.parse(param) }}</pre>
                <pre v-else>{{ param }}</pre>
            </div>
        </div>

    </div>
</template>
<script>

export default {
    name: "TaskModalParams",
    props: ['params']
}
</script>
<style lang="scss" scoped>
.params{
    width: 100%;
    text-align: left;
    padding: 10px;
    textarea{
        width: 100%;
        height: 100%;
    }
  pre{
    text-align: left;
  }
}

</style>
